// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"application_mainContainer__aWSG1"};